import { normalize } from "common/lib/normalize";
import { getPositionTypes } from "common/services/payments.service";
import { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { FormFeedback, Label } from "reactstrap";

const SelectPositionType = ({ validation }: { validation: any }) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.positionType && validation.errors.positionType
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.positionType && validation.errors.positionType
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = useState([]);
  const [, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getPositionTypes({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
        });

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    const mainOptions = data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
    mainOptions.unshift({ value: null, label: "None" });
    return mainOptions;
  }, [data]);

  return (
    <>
      <Label htmlFor="positionType-field" className="form-label">
        Position Type
      </Label>
      <Select
        name="positionType"
        id="positionType"
        value={
          validation.values.positionType.value
            ? validation.values.positionType
            : null
        }
        isSearchable={false}
        placeholder="Select position type"
        onChange={(value: any) => {
          validation.setFieldValue("positionType", value);
          validation.setFieldError("positionType", "");
        }}
        options={options}
        onBlur={() => validation.setFieldTouched("positionType", true)}
        className={
          validation.touched.positionType && validation.errors.positionType
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
      />
      <FormFeedback>{validation.errors.positionType?.value}</FormFeedback>
    </>
  );
};

export default SelectPositionType;
